<template>
  <!-- <div id="container" ref="mapRef" class="mainBox"> -->
    <div id="container" class="mainBox">
      <!-- <iframe  id="iframeContain"  name="iframeContain"  seamless  scrolling="yes"  src="http://lcdata.laicun.wang/bd/3dmap" ></iframe>
 -->
      <iframe src="3dmap" style="width:100%;height:100%;border: none;"></iframe>
       <!--顶部  -->
      <div class="topBg"><nyTit  pathUrl='/binghai'/></div>
      <div class="bottomBg"></div>
      <div class="center"><navItem />></div>
        <!-- z左侧 -->
        <div class="left">
          <div class="title"><span>视频监控</span></div>
          <div class="leftBox1" id="video1">
            <div class="videoItem" v-for="(item,index) in state.leftVideo" :key="index">
              <div class="videoBg">
                <vue3VideoPlay id="video"   ref="videoRef"   width="100%"    height="100%"  title="视频监控" :src="item.options.src" :type="item.options.type" :autoPlay="true" :muted="true" :control="false" @loadedmetadata="onLoadedMetadata" />
              </div>
              <div class="videoTabList"><div class="videoTabItem" v-for="(item1,index1) in item.tabList" :key="index1">{{item1}}</div></div>
            </div>
          </div>

        </div>
        <!-- 右侧 -->
        <div class="right">

          <div class="rightBox1">
            <div class="rightBox1_l">
              <div class="title"><span>数据中心</span></div>
              <div class="leftBox1Content">
                <div class="leftBox1ContentTop">
                  <div class="circle"></div>
                  <img src="../assets/img/gbzntyj/gaungai/gg.png" class="circleImg" />
                  <div class="leftBox1ContentTopList" v-if="state.showDiv">
                    <div v-for="(item,index) in state.leftData1A" :key="index" class="leftBox1ContentTopItem  animate__animated" :class="index==0||index==2 ? 'animate__fadeInLeft' : 'animate__fadeInRight'">
                      <div class="contentLine contentLine1"></div>
                      <div class="contentLine contentLine2"></div>
                      <div class="contentLine contentLine3"></div>
                      <div class="contentLine contentLine4"></div>
                      <span class="txt1">{{item.name}}</span><span class="txt2">{{item.value}}{{item.unit}}</span>
                    </div>
                  </div>
                </div>
                <div class="leftBox1ContentCenter">
                  <div class="dateItem" :class="{dateItemCur:state.left1Cur==index}" v-for="(item,index) in state.leftData1Date" :key="index" @click="tabDate(dateItemCur)">{{item}}</div>
                </div>
                <div class="leftBox1ContentBottom">
                  <div class="leftBox1ContentBottom1 animate__animated animate__fadeInLeft"  v-if="state.showDiv">
                    <div class="leftBox1ContentBottomItem" v-for="(item,index) in state.leftData1B" :key="index">
                      <div class="leftItem"><img :src="item.icon" class="img" /></div>
                      <div class="rightCon"><span class="txt1">{{item.value}}</span><span class="txt2">{{item.name}}</span></div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="rightBox1_r">
              <div class="rightBox1_r_top">
                <div class="title"><span>灌溉控制中心</span></div>
                <div class="rightBox1_r_top_List">
                  <div class="rightBox1_r_top_item" v-for="(item,index) in state.rightKz" :key="index">
                    <h6>{{item.name}}</h6>
                    <div class="rightBox1_r_top_status"><span :class="{isOpen:item.isOpen}" @click="clickIsOpen(index,0)">开启</span><span :class="{isClose:!item.isOpen}" @click="clickIsOpen(index,1)">关闭</span></div>
                  </div>
                </div>
              </div>
              <div class="rightBox1_r_bottom">
                <div class="title1">灌溉水量</div>
                <div class="echartBox"><rightLine /></div>
              </div>

            </div>
          </div>
          <div class="rightBox2">
            <div class="title"><span>水肥变化量</span></div>
            <div class="echartBox" ><LeftBar /></div>
          </div>
<!--          <div class="rightBox2">-->
<!--            <div class="title"><span>灌溉水量</span></div>-->
<!--            <div class="echartBox"><rightLine /></div>-->
<!--          </div>-->
        </div>

  </div>
  <footer1 />
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
  watch
} from "vue";

// todo 项目使用请放开 leaflet 引入
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";
// // import * as L from 'leaflet/dist/leaflet.esm.js';
// import Gep from "../utils/范围面.json";
// import ldt from "../components/gbzntyj/ldt.vue";
// import dczz from "../components/gbzntyj/dczz.vue";
import nyTit from '@/components/nyTit'
import navItem from '@/components/nyNav'
import LeftBar from "../components/ZhinengGG/LeftBar"
import rightLine from "../components/ZhinengGG/rightLine"
import footer1 from "../components/footer.vue";


let statusUpdateInterval;
// const timer = ref(null);
const router = useRouter();
const videoRef = ref(null);
const state = reactive({
  leftData1A:[{name:"总流量",value:"0.01",unit:"m³/h"},{name:"运行速度",value:"45.0",unit:"m/h"},{name:"水渠液位",value:"0.3",unit:"m"},{name:"运行时间",value:"0.3",unit:"h"}],
  leftData1Date:["3.01","3.02","3.03","3.04","3.05","3.06","3.07"],
  left1Cur:0,
  leftData1B:[{name:"灌溉水量",value:"0.00",unit:"m³",icon:require('@/assets/img/gbzntyj/gaungai/sl.png')},{name:"灌溉亩数",value:"0.00",unit:"亩",icon:require('@/assets/img/gbzntyj/gaungai/ms.png')},{name:"亩均灌溉量",value:"0.00",unit:"m³/亩",icon:require('@/assets/img/gbzntyj/gaungai/pj.png')}],
  showDiv:true,
  rightKz:[
    {name:"总阀",isOpen:false},
    {name:"地块1进水",isOpen:true},
    {name:"地块2进水",isOpen:false},
    {name:"地块3进水",isOpen:false}
  ],
  leftVideo:[{
    options: { src: require("@/assets/video/zzng.mp4"), type: "video/mp4" },
    tabList: ["固定喷灌", "指针喷灌"]
    },{
    options: { src: require("@/assets/video/gg.mp4"), type: "video/mp4" },
    tabList: [ "平移喷灌", "水肥一体机"]
    },{
    options: { src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/1.mp4", type: "video/mp4" },
    tabList: ["桁架式喷灌", "卷盘式喷灌"]
  },{
    options: { src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/11.mp4", type: "video/mp4" },
    tabList: [ "平移式喷灌", "水肥一体机"]
  }
  ],
    status:1,
    currentTime1:0,
    laststatus:0
});





// 在 onMounted 中初始化地图

 onMounted(() => {
  statusUpdateInterval = setInterval(async () => {
    const res = await axios.post(
      "https://smartfarm.laicunwang.com/api/index/datagg",
      {
        sign: "c4c6cff9b7ec6b87fa953f77ec7e624b",
      }
    );

    state.laststatus = res.data.data.status;
    // state.laststatus += 1;
    console.log(state.laststatus);
  }, 3000);
});
 function clickIsOpen(index,type){
   state.rightKz[index].isOpen = ! state.rightKz[index].isOpen
 }
function handleVideoStatusChange(newLastStatus) {
      if (videoRef.value) {
        if (newLastStatus == 1) {
          videoRef.value.play(); // 当 laststatus 变为 1 时开始播放
        } else if (newLastStatus == 2) {
          videoRef.value.pause(); // 当 laststatus 变为 2 时暂停播放
        }
      }
}
// function onLoadedMetadata() {
//     state.options.autoPlay = false;
//     videoRef.value.pause(); // 在元数据加载完成后立即暂停视频
//
//     watch(
//       () => state.laststatus,
//       (newLastStatus, oldLastStatus) => {
//         console.log(
//           "laststatus 变化了：",
//           newLastStatus,
//           "（旧值：",
//           oldLastStatus,
//           "）"
//         );
//         handleVideoStatusChange(newLastStatus);
//       },
//       { immediate: true }
//     );
// }

function onPlayerReady(){
  console.log("kk")
}
// 返回上一页
function clickReturn() {
  router.go(-1);
}
function tabDate(index){
  this.showDiv = false; // 点击后先隐藏div
  state.left1Cur = index
  setTimeout(() => {
    state.showDiv = true; // 200ms后再重新显示div（模拟刷新）
  }, 200);
}

onUnmounted(() => {
  clearInterval(statusUpdateInterval);
});
onBeforeUnmount(() => {
  // clearInterval(timer.value);
});



</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
  font-size: 14px;
  overflow: hidden;
}
#echartBox{
  font-size: 14px;
}
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state{
  top: 50%;
  display: none;
}
::v-deep .d-icon{
  font-size: 20px!important;
}
::v-deep .d-player-wrap .d-player-control{
  height: 30px;
}
#video1 .d-player-wrap,#video2 .d-player-wrap  {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}
#iframeContain{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
}
.mainBox {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  .topBg{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 432px;
    background: url("../assets/img/gbzntyj/bingchong/s.png") no-repeat;
    z-index: 1;
  }
  .bottomBg{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 432px;
    background: url("../assets/img/gbzntyj/bingchong/x.png") no-repeat;
  }
  .center{
    position: absolute;
    bottom: 90px;
    left: 50%;
    width: 2000px;
    margin-left: -1000px;

  }


    .left,.right{
      width: 1530px;
      height: 100%;
      position: absolute;
      top: 0;
      display: flex;
      flex-direction: column;
      position: absolute;
      box-sizing: border-box;
      background: #071315;
      padding-top: 150px;
    }
  .title{
    width: 972px;
    height: 130px;
    line-height: 40px;
    background: url("../assets/img/gbzntyj/qixiang1/cgx.png") no-repeat left bottom;
    color: #fff;
    font-size: 40px;
    margin: 20px auto 0;
    position: relative;
    z-index: 999;
    span{
      background: linear-gradient(to bottom, #fff 25%, #FFD791 95%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: bold;
    }
  }
  .title1{
    background: url("../assets/img/plant/title.png") no-repeat left bottom;
    width: 100%;
    height: 70px;
    line-height: 60px;
    color: #fff;
    font-size: 32px;
    text-align: left;
    padding-left: 60px;
    margin-bottom: 20px;
  }
    .echartBox{
        width: 100%;
        flex: 1;
      }
    .left{
      left: 0;
      padding-left: 34px;
      height: 100%;
      display: flex;
      flex-direction: column;
      .leftBox1{
        position: relative;
        z-index: 1000;
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        padding: 0 30px 50px 0;
        margin-top: -30px;
        .videoItem{
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .videoBg{
            background: url("../assets/img/gbzntyj/gaungai/spk.png") no-repeat;
            background-size: 100% 100%!important;
            width: 662px;
            height: 389px;
            padding: 12px;
            overflow: hidden;
            margin: 0 30px;
          }
          .videoTabList{
            display: flex;
            width: 562px;
            height: 114px;
            justify-content: space-between;
            margin-top: 30px;
            .videoTabItem{
              width: 210px;
              height: 114px;
              background: url("../assets/img/gbzntyj/gaungai/pg.png") no-repeat;
              font-size: 30px;
              color: #04DFE4;
              text-align: center;
              line-height: 114px;
            }
          }
        }
      }

      
    }
    .right{
      right: 0;
      padding-right: 34px;
      align-items: flex-end;
      .rightBox1{
        position: relative;
        z-index: 1000;
        width: 100%;
        flex: 1;
        display: flex;
        .rightBox1_l{
          width: 667px;
          display: flex;
          flex-direction: column;
          margin-left: 50px;
          .title{
            width: 100%;
            height: 100px;
            background: url("../assets/img/plant/dbt.png") no-repeat center bottom;
          }
          .leftBox1Content{
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-top: 50px;
            .leftBox1ContentTop{
              width: 100%;
              height: 239px;
              background: url("../assets/img/gbzntyj/gaungai/x.png") no-repeat center center;
              position: relative;
              //margin: 30px 0 50px;
              .circle{
                position: absolute;
                top: 50%;
                left: 50%;
                width: 324px;
                height: 324px;
                background: url("../assets/img/gbzntyj/gaungai/nq.png") no-repeat center center;
                margin: -162px 0 0 -162px;
                animation: guangying 2s linear infinite;
              }
              .circleImg{
                position: absolute;
                top: 50%;
                left: 50%;
                z-index: 999;
                width: 36px;
                height: 38px;
                margin: -19px 0 0 -18px;
                animation: left1Img 2s linear infinite;

              }
              .leftBox1ContentTopList{
                width: 100%;
                height: 100%;
                position: relative;
                .leftBox1ContentTopItem{
                  width: 156px;
                  height: 86px;
                  background: url("../assets/img/gbzntyj/gaungai/llk.png") no-repeat;
                  position: absolute;
                  z-index: 999;
                  overflow: hidden;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  line-height: 32px;
                  span{
                    display: block;
                    font-size: 24px;
                  }
                  span.txt1{
                    color: #fff;
                    opacity: .9;
                  }
                  span.txt2{
                    color: #00E9EF;
                    font-weight: bold;
                    font-size: 26px;
                  }
                }
                .leftBox1ContentTopItem:nth-child(1){
                  top: -8px;
                  left: 4px;
                }
                .leftBox1ContentTopItem:nth-child(2){
                  top: -8px;
                  right: 6px;
                }
                .leftBox1ContentTopItem:nth-child(3){
                  bottom: -8px;
                  left: 4px;
                }
                .leftBox1ContentTopItem:nth-child(4){
                  bottom: -8px;
                  right: 6px;
                }
              }
            }
            .leftBox1ContentCenter{
              width: 100%;
              height: 65px;
              background: url("../assets/img/gbzntyj/gaungai/rq.png") no-repeat;
              line-height: 65px;
              padding: 0 70px;
              box-sizing: border-box;
              display: flex;
              justify-content: space-between;
              .dateItem{
                font-size: 26px;
                color: #Fff;
                cursor: pointer;
              }
              .dateItem:hover,.dateItemCur{color: #ffc600;}
            }
            .leftBox1ContentBottom{
              width: 100%;
              height: 66px;
              .leftBox1ContentBottom1{
                display: flex;
                width: 100%;
                height: 100%;
              }
              .leftBox1ContentBottomItem{
                flex: 1;
                display: flex;
                font-size: 26px;
                .leftItem{
                  background: url("../assets/img/gbzntyj/gaungai/slk.png") no-repeat;
                  width: 72px;
                  height: 66px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  position: relative;
                  .img{
                    width: 35px;
                    height: 35px;
                    //animation: left1Img 1s linear infinite;

                  }
                }
                .rightCon{
                  display: flex;
                  flex-direction: column;
                  margin-left: 10px;
                  span{
                    display: block;
                    text-align: left;
                    transform:perspective(1px)
                  }
                  span.txt1{
                    color: #00F6F8;
                    font-weight: bold;
                  }
                  span.txt2{
                    color: #fff;
                    font-style: normal;
                  }
                }
              }
            }
        }
        }
        .rightBox1_r{
          flex: 1 ;
          display: flex;
          flex-direction: column;
          padding: 0 60px 0 80px;
          .rightBox1_r_top{
            height: 365px;
            .title{
              width: 100%;
              height: 100px;
              background: url("../assets/img/plant/dbt.png") no-repeat center bottom;
            }
            .rightBox1_r_top_List{
              width: 100%;
              flex: 1;
              display: flex;
              flex-wrap: wrap;
              font-size: 30px;
              justify-content: space-between;
              margin-top: -10px;
              padding-left: 50px;
              .rightBox1_r_top_item{
                width: 45%;

                h6{
                  color: #fff;
                  line-height: 50px;
                  text-align: left;
                  font-size: 26px;
                  font-weight: normal;
                  margin: 10px 0;
                }
                .rightBox1_r_top_status{
                  display: flex;
                  justify-content: space-between;
                  span{
                    display: block;
                    width: 128px;
                    height: 50px;
                    text-align: center;
                    line-height: 50px;
                    background: #05232E;
                    color: #00798B;
                    border-radius: 6px;
                    font-size: 26px;
                    cursor: pointer;
                  }
                  span.isOpen{
                    background: #0CB3A5;
                    color: #fff;
                  }
                  span.isClose{
                    background: #DE5954;
                    color: #fff;
                  }
                }
              }
            }
          }
          .rightBox1_r_bottom{
            width: 100%;
            flex: 1;
            display: flex;
            flex-direction: column;
          }
        }
      }
      .rightBox2{
        width: 100%;
        height: 760px;
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        .echartBox{
          margin-top: -20px;
        }
      }

    }
    



}
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

@keyframes left1Img {
  /*引用动画名称*/
  0% {
    transform: scale(1);
  }
50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes left2Img {
  /*引用动画名称*/
  0% {
    margin-top: 0;
  }
50% {
    margin-top: 5px;
  }
  100% {
    margin-top: 0;
  }
}
@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
     animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
   
  }
}

.contentLine {
  background: #1AA19E;
  position: absolute;
}
.contentLine1{
  top: 1px;
  left: 0;
  width: 10%;
  height: 2px;
  /* 加上渐变效果，方可形成拖尾效果 */
  background: linear-gradient(90deg, transparent, #1AA19E);
  animation: animate1 4s linear infinite;
}
.contentLine2{
  top: -100%;
  right: 0;
  width: 2px;
  height: 20%;
  background: linear-gradient(180deg, transparent, #1AA19E);
  animation: animate2 4s linear infinite;
  /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
  animation-delay: 1s;
}
.contentLine3{
  bottom: 1px;
  right: 0;
  width: 20%;
  background: linear-gradient(270deg, transparent, #1AA19E);
  animation: animate3 4s linear infinite;
  animation-delay: 2s;
}
.contentLine4{
  bottom: -100%;
  left: 1px;
  width: 2px;
  height: 10%;
  background: linear-gradient(360deg, transparent, #1AA19E);
  animation: animate4 4s linear infinite;
  animation-delay: 3s;
}
/* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
0% {
      transform: rotate(0deg);
  }

100% {
  transform: rotate(-360deg);
}
}

@keyframes animate1 {
0% {
    left: -50%;
}

50%,
100% {
    left: 100%;
}
}

@keyframes animate2 {
0% {
    top: -100%;
}

50%,
100% {
    top: 100%;
}
}
@keyframes animate3 {
0% {
    right: -100%;
    height: 3px;
}

50%,
100% {
    height: 2px;
    right: 100%;
}
}
@keyframes animate4 {
0% {
    bottom: -100%;
}

50%,
100% {
    bottom: 100%;
}
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
